<template>
  <div class="d-flex flex-wrap w-100">
    <div
      v-for="(picture, index) in pictures"
      :key="picture.id"
      class="avatar-container p-2 mx-1"
      @click="openGallery(index)"
    >
      <div class="avatar">
        <img :src="picture.url" alt="" class="avatar-img rounded" />
        <div class="layout">
          <button v-if="canDelete" class="btn btn-danger text-white p-1 px-2" title="Eliminar" @click="remove(index)">
            <i class="fas fa-trash"></i>
          </button>
        </div>
      </div>
      <div class="pr-1 pl-1 mt-1 text-justify text-muted small">{{ picture.description }}</div>
    </div>
    <vue-easy-lightbox :imgs="images" :index="index" :visible="visible" @hide="handleHide" />
  </div>
</template>

<script>
import VueEasyLightbox from 'vue-easy-lightbox';

export default {
  components: {
    VueEasyLightbox,
  },

  props: {
    pictures: {
      type: Array,
      default: () => {
        return [];
      },
    },

    showGallery: {
      type: Boolean,
      default: false,
    },

    canDelete: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      images: [],
      visible: false,
      showingIndex: 0,
    };
  },

  methods: {
    openGallery(index) {
      if (!this.pictures[index]) {
        return;
      }

      if (this.showGallery) {
        this.images = this.pictures.map((i) => i.url);
        this.showingIndex = index;
        this.show();
      }

      this.$emit('open-gallery', this.pictures[index].id);
    },

    show() {
      this.visible = true;
    },

    handleHide() {
      this.visible = false;
    },

    remove(index) {
      const picture = this.pictures[index];
      this.$services.resource('quotation_pictures').delete(picture.id);
      this.$emit('imageDeleted', index);
    },
  },
};
</script>

<style scoped>
.avatar-container {
  max-width: 170px !important;
}

.avatar {
  width: 150px;
  height: 150px;
  cursor: pointer;
}

.avatar img {
  object-fit: cover;
  width: 150px;
  height: 150px;
}

.layout {
  position: absolute;
  width: 150px;
  height: 150px;
}

.layout:hover {
  background: #2d2d2d55;
}

.layout button {
  color: white;
  position: absolute;
  top: 0;
  right: 0;
}

.layout button:hover {
  color: #f5365c;
}
</style>
